export const AuthDanysMenors = ({ auth, handleChange, error }) => {

  return (<>
    <div className="row">
      <div className="col col-12 ">
        <h4>
          Responsabilització de danys
        </h4>
        <p>
          <input type="checkbox" id="authDanys" name="authDanys" value={auth} checked={auth === "1" ? true : false} onChange={(t) => { handleChange(t.target.value) }} required />
          <label htmlFor="authDanys">
            Em responsabilitzo de tots aquells danys en persones o coses que pugui causar el meu/va fill/a com a conseqüència de la seva actuació negligent o imprudent, d’acord amb la legislació vigent.
          </label>
          <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>
        </p>

      </div>
    </div>
  </>)
}

export const AuthDanys = ({ auth, handleChange, error }) => {

  return (<>
    <div className="row">
      <div className="col col-12 ">
        <h4>
          Responsabilització de danys
        </h4>
        <p>
          <input type="checkbox" id="authDanys" name="authDanys" value={auth} checked={auth === "1" ? true : false} onChange={(t) => { handleChange(t.target.value) }} required />
          <label htmlFor="authDanys">
            Em responsabilitzo de tots aquells danys en persones o coses que pugui causar com a conseqüència d'una actuació negligent o imprudent, d’acord amb la legislació vigent.
          </label>
          <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>
        </p>

      </div>
    </div>
  </>)
}
